import { FormMetricVM } from 'practice/components/metric/form';
import { HttpResponse } from 'shell/models/http-response';
import { MetricData } from 'shell/models/type-metric';
import { AxiosResponse } from 'axios';
import { DateTime } from 'luxon';

export const metricResponseTransformer = (
  response: AxiosResponse<HttpResponse<MetricData>>
): FormMetricVM => {
  const { data } = response;
  const item = data.payload;
  return {
    hoursMax: item?.numMaxOreOperazione || undefined,
    hoursWarning: item?.numOrePerWarning || undefined,
    operation: item.key?.tipoOperazione || '',
    register: item.key?.tipoRegistro || '',
    state: item.key?.codStatoPratica || '',
    practice: item.key?.tipoPratica || '',
    validityFrom: item.key?.dataAttivazione ? DateTime.fromISO(item.key.dataAttivazione) : null,
    validityTo: item?.dataDisattivazione ? DateTime.fromISO(item.dataDisattivazione) : null,
  };
};
